import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { APP_COPY } from '../../constants/copy';
import './header.scss';

const Header = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const scrollToContact = () => {
    setIsNavCollapsed(true);
    
    // Debug: Log current page and check for contact element
    console.log('Current pathname:', window.location.pathname);
    console.log('Looking for contact element...');
    
    // Use a more robust approach with multiple attempts
    const attemptScroll = (attempts = 0) => {
      const contactElement = document.getElementById('contact');
      console.log(`Attempt ${attempts + 1}: Contact element found:`, !!contactElement);
      
      if (contactElement) {
        console.log('Scrolling to contact element');
        contactElement.scrollIntoView({ behavior: 'smooth' });
      } else if (attempts < 10) {
        // Try again after a short delay
        setTimeout(() => attemptScroll(attempts + 1), 100);
      } else {
        // If still not found after multiple attempts, navigate to home
        console.log('Contact element not found, navigating to home');
        window.location.href = '/#contact';
      }
    };
    
    attemptScroll();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          {APP_COPY.header.title}
        </Link>
        
        <button
          className={`navbar-toggler${!isNavCollapsed ? ' open' : ''}`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed ? true : false}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          <span className="toggler-bar"></span>
          <span className="toggler-bar"></span>
          <span className="toggler-bar"></span>
        </button>
        
        <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {[
              { href: "/", label: APP_COPY.header.nav.home, isLink: true },
              { href: "/retreats", label: APP_COPY.header.nav.retreats, isLink: true },
              { href: "#contact", label: APP_COPY.header.nav.contact, isLink: false, onClick: scrollToContact },
            ].map((item) => (
              <li className="nav-item" key={item.href}>
                {item.isLink ? (
                  <Link className="nav-link" to={item.href} onClick={() => setIsNavCollapsed(true)}>
                    {item.label}
                  </Link>
                ) : (
                  <a className="nav-link" href={item.href} onClick={item.onClick}>
                    {item.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header; 